/*
 * c-gift-options — ギフト用オプション（のし・リボン）の開閉・送信値・未入力チェック・カルーセル
 * リボンはオンの時だけ、本体＋リボンを /cart/add.js の items 配列で1回に入れる（下の「リボン」）
 * snippets/c-gift-options.liquid から読み込む。1ページに複数フォームがあっても動くよう、
 * すべて document へのイベント委譲で処理する（テーマエディタでのセクション再読込にも追従）。
 *
 * 送信値の出し分けは disabled で行う（theme.utils.serialize・通常 submit とも disabled は送らない）。
 * 未入力チェックは次の3経路で止める:
 *   1. カートに追加（テーマの AJAX カート）… form の submit を document の capture で先取り
 *   2. 通常 submit … 1 と同じ
 *   3. 今すぐ購入（dynamic checkout）… .shopify-payment-button の click を capture で先取り
 */
(function () {
  if (window.cGiftOptions) return;

  var SEL = {
    noshi: '[data-c-noshi]',
    toggle: '[data-c-noshi-toggle]',
    detail: '[data-c-noshi-detail]',
    purpose: '[data-c-noshi-purpose]',
    panel: '[data-c-noshi-panel]',
    type: '[data-c-noshi-type]',
    color: '[data-c-noshi-color]',
    nameMode: '[data-c-noshi-name-mode]',
    nameSend: '[data-c-noshi-name-send]',
    fields: '[data-c-noshi-fields]',
    text: '[data-c-noshi-text]',
    send: '[data-c-noshi-send]',
    track: '[data-c-noshi-track]',
    slide: '[data-c-noshi-slide]',
    carousel: '[data-c-noshi-carousel]',
    counter: '[data-c-noshi-counter]'
  };

  function $(root, sel) { return root.querySelector(sel); }
  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }
  function block(noshi, key) { return $(noshi, '[data-c-noshi-block="' + key + '"]'); }
  function checked(root, sel) { return $(root, sel + ':checked'); }

  function isOn(noshi) {
    var on = $(noshi, SEL.toggle + '[value="on"]');
    return !!(on && on.checked);
  }

  function setHidden(el, hidden) { if (el) el.hidden = hidden; }

  function showError(noshi, key, show) {
    var error = $(noshi, '[data-c-noshi-error="' + key + '"]');
    if (error) error.hidden = !show;
  }

  function clearErrors(noshi) {
    $$(noshi, '[data-c-noshi-error]').forEach(function (e) { e.hidden = true; });
  }

  // 名入れ: モードに応じて欄を出し、空でない欄だけ送る
  function syncName(noshi, active) {
    var modeInput = checked(noshi, SEL.nameMode);
    var mode = active && modeInput ? modeInput.value : '';
    var modeSend = $(noshi, SEL.nameSend);
    if (modeSend) {
      modeSend.value = mode;
      modeSend.disabled = mode === '';
    }
    $$(noshi, SEL.fields).forEach(function (group) {
      var visible = mode !== '' && group.getAttribute('data-c-noshi-fields') === mode;
      group.hidden = !visible;
      $$(group, '.c-gift-options__field').forEach(function (field) {
        var text = $(field, SEL.text);
        var send = $(field, SEL.send);
        var value = text ? text.value.trim() : '';
        send.value = value;
        send.disabled = !visible || value === '';
      });
    });
  }

  function updateCounter(carousel) {
    var track = $(carousel, SEL.track);
    var counter = $(carousel, SEL.counter);
    if (!track || !counter) return;
    var slides = $$(track, SEL.slide);
    if (!slides.length) return;
    var step = slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : slides[0].offsetWidth;
    var index = step > 0 ? Math.round(track.scrollLeft / step) : 0;
    var perView = step > 0 ? Math.max(1, Math.round(track.clientWidth / step)) : 1;
    var last = Math.min(slides.length, index + perView);
    counter.textContent = (perView > 1 ? (index + 1) + '–' + last : last) + ' / ' + slides.length;
  }

  function updateNoshi(noshi) {
    var on = isOn(noshi);
    setHidden($(noshi, SEL.detail), !on);

    var purposeInput = on ? checked(noshi, SEL.purpose) : null;
    var purpose = purposeInput ? purposeInput.value : '';
    var choji = !!(purposeInput && purposeInput.hasAttribute('data-choji'));

    setHidden(block(noshi, 'type'), !purpose);
    $$(noshi, SEL.panel).forEach(function (panel) {
      var active = panel.getAttribute('data-c-noshi-panel') === purpose;
      var wasHidden = panel.hidden;
      panel.hidden = !active;
      $$(panel, SEL.type).forEach(function (input) {
        input.disabled = !active;
        if (!active) input.checked = false;
      });
      if (active && wasHidden) {
        var track = $(panel, SEL.track);
        if (track) track.scrollLeft = 0;
        var carousel = $(panel, SEL.carousel);
        if (carousel) requestAnimationFrame(function () { updateCounter(carousel); });
      }
    });

    setHidden(block(noshi, 'color'), !choji);
    $$(noshi, SEL.color).forEach(function (input) {
      input.disabled = !choji;
      if (!choji) input.checked = false;
    });

    syncName(noshi, on);
    if (!on) clearErrors(noshi);
  }

  // 未入力の項目を返す（無ければ null）: { noshi, key }
  function findInvalid(form) {
    if (!form) return null;
    var list = $$(form, SEL.noshi);
    for (var i = 0; i < list.length; i++) {
      var noshi = list[i];
      if (!isOn(noshi)) continue;
      var purposeInput = checked(noshi, SEL.purpose);
      if (!purposeInput) return { noshi: noshi, key: 'purpose' };
      if (!checked(noshi, SEL.type)) return { noshi: noshi, key: 'type' };
      if (purposeInput.hasAttribute('data-choji') && !checked(noshi, SEL.color)) return { noshi: noshi, key: 'color' };
      var mode = checked(noshi, SEL.nameMode);
      if (mode && mode.value) {
        var group = $(noshi, '[data-c-noshi-fields="' + mode.value + '"]');
        var missing = group && $$(group, SEL.text + '[data-required]').some(function (t) { return t.value.trim() === ''; });
        if (missing) return { noshi: noshi, key: 'name' };
      }
    }
    return null;
  }

  function stop(evt, invalid) {
    evt.preventDefault();
    evt.stopPropagation();
    evt.stopImmediatePropagation();
    clearErrors(invalid.noshi);
    showError(invalid.noshi, invalid.key, true);
    var target = block(invalid.noshi, invalid.key) || invalid.noshi;
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  document.addEventListener('change', function (evt) {
    var target = evt.target;
    if (!target.closest) return;
    var noshi = target.closest(SEL.noshi);
    if (!noshi) return;
    if (target.matches(SEL.toggle) || target.matches(SEL.purpose) || target.matches(SEL.nameMode)) updateNoshi(noshi);
    if (target.matches(SEL.purpose)) showError(noshi, 'purpose', false);
    if (target.matches(SEL.type)) showError(noshi, 'type', false);
    if (target.matches(SEL.color)) showError(noshi, 'color', false);
    if (target.matches(SEL.nameMode)) showError(noshi, 'name', false);
  });

  document.addEventListener('input', function (evt) {
    var target = evt.target;
    if (!target.matches || !target.matches(SEL.text)) return;
    var noshi = target.closest(SEL.noshi);
    syncName(noshi, isOn(noshi));
    showError(noshi, 'name', false);
  });

  // カルーセル: 前後ボタン・シーンへ移動
  document.addEventListener('click', function (evt) {
    var target = evt.target;
    if (!target.closest) return;
    var button = target.closest('[data-c-noshi-prev],[data-c-noshi-next],[data-c-noshi-jump]');
    if (!button) return;
    var panel = button.closest(SEL.panel);
    var track = panel && $(panel, SEL.track);
    if (!track) return;
    var slides = $$(track, SEL.slide);
    if (!slides.length) return;
    var left;
    if (button.hasAttribute('data-c-noshi-jump')) {
      var first = $(track, '[data-scene="' + button.getAttribute('data-c-noshi-jump') + '"]');
      if (!first) return;
      left = first.offsetLeft - slides[0].offsetLeft;
    } else {
      var step = slides.length > 1 ? slides[1].offsetLeft - slides[0].offsetLeft : track.clientWidth;
      left = track.scrollLeft + (button.hasAttribute('data-c-noshi-next') ? step : -step);
    }
    track.scrollTo({ left: left, behavior: 'smooth' });
  });

  document.addEventListener('scroll', function (evt) {
    var track = evt.target;
    if (!track.matches || !track.matches(SEL.track)) return;
    updateCounter(track.closest(SEL.carousel));
  }, true);

  // 1・2: カートに追加（テーマの submit リスナーより先に動く）
  document.addEventListener('submit', function (evt) {
    var invalid = findInvalid(evt.target);
    if (invalid) stop(evt, invalid);
  }, true);

  // 3: 今すぐ購入（dynamic checkout は submit を発火しない）
  document.addEventListener('click', function (evt) {
    var target = evt.target;
    if (!target.closest) return;
    var button = target.closest('.shopify-payment-button');
    if (!button) return;
    var invalid = findInvalid(button.closest('form'));
    if (invalid) stop(evt, invalid);
  }, true);

  /*
   * リボン（#3）
   * オンの時だけ submit を先取りし、本体と同じ数量のリボンを /cart/add.js の items 配列で1回に入れる。
   * のしの未入力チェック（上の capture submit）が先に登録されているので、のしで止まればここには来ない。
   * オフの時は何もしない（テーマの通常の追加のまま）。
   */
  var ribbonBusy = false;

  function ribbonOf(form) {
    var ribbon = form && $(form, '[data-c-ribbon]');
    var toggle = ribbon && $(ribbon, '[data-c-ribbon-toggle]');
    return toggle && toggle.checked ? ribbon : null;
  }

  function ribbonError(ribbon, key) {
    $$(ribbon, '[data-c-ribbon-error]').forEach(function (e) {
      e.hidden = e.getAttribute('data-c-ribbon-error') !== key;
    });
  }

  // 本体の明細: フォームの送信値（disabled・未チェックは FormData に入らない＝のしの出し分けがそのまま効く）
  function lineFromForm(form) {
    var data = new FormData(form);
    var line = { id: parseInt(data.get('id'), 10), quantity: parseInt(data.get('quantity'), 10) || 1 };
    if (data.get('selling_plan')) line.selling_plan = data.get('selling_plan');
    var properties = {};
    data.forEach(function (value, name) {
      var m = /^properties\[(.+)\]$/.exec(name);
      if (m && typeof value === 'string') properties[m[1]] = value;
    });
    if (Object.keys(properties).length) line.properties = properties;
    return line;
  }

  function ribbonTarget(ribbon, variantId) {
    var name = ribbon.getAttribute('data-c-ribbon-target') || '';
    var map = $(ribbon, '[data-c-ribbon-variants]');
    if (map) {
      try {
        var title = JSON.parse(map.textContent)[variantId];
        if (title) name += ' / ' + title;
      } catch (e) { /* 対象名は商品名だけにする */ }
    }
    return name;
  }

  document.addEventListener('submit', function (evt) {
    if (evt.defaultPrevented) return;
    var form = evt.target;
    var ribbon = ribbonOf(form);
    if (!ribbon) return;
    evt.preventDefault();
    evt.stopPropagation();
    evt.stopImmediatePropagation();
    if (ribbonBusy) return;

    var body = lineFromForm(form);
    if (!body.id) return;
    var items = [body, {
      id: parseInt(ribbon.getAttribute('data-c-ribbon-variant'), 10),
      quantity: body.quantity,
      properties: { '対象商品': ribbonTarget(ribbon, body.id) }
    }];

    var button = $(form, '[data-add-to-cart]') || $(form, '[type="submit"]');
    ribbonBusy = true;
    ribbonError(ribbon, '');
    if (button) button.classList.add('btn--loading');

    var theme = window.theme || {};
    var routes = theme.routes || {};
    fetch(routes.cartAdd || '/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: items })
    })
      .then(function (response) {
        return response.json().then(function (json) {
          if (!response.ok || json.status) throw json;
          return json;
        });
      })
      .then(function (json) {
        if (theme.settings && theme.settings.cartType === 'drawer') {
          // テーマの AJAX 追加と同じ合図でドロワーを開く（theme.CartDrawer が受けて描き直す）
          form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
            detail: { product: json.items && json.items[0], addToCartBtn: button },
            bubbles: true
          }));
        } else {
          window.location.href = routes.cartPage || '/cart';
        }
      })
      .catch(function (error) {
        console.warn('[c-gift-options] ribbon', error);
        var message = error && (error.description || error.message);
        var box = $(ribbon, '[data-c-ribbon-error="add"]');
        if (box && message && typeof message === 'string') box.textContent = message;
        ribbonError(ribbon, 'add');
      })
      .then(function () {
        ribbonBusy = false;
        if (button) button.classList.remove('btn--loading');
      });
  }, true);

  // 今すぐ購入ではリボンを付けられないので、オンなら止めて案内する
  document.addEventListener('click', function (evt) {
    var target = evt.target;
    if (!target.closest) return;
    var button = target.closest('.shopify-payment-button');
    if (!button) return;
    var ribbon = ribbonOf(button.closest('form'));
    if (!ribbon) return;
    evt.preventDefault();
    evt.stopPropagation();
    evt.stopImmediatePropagation();
    ribbonError(ribbon, 'checkout');
    ribbon.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, true);

  document.addEventListener('change', function (evt) {
    var target = evt.target;
    if (!target.matches || !target.matches('[data-c-ribbon-toggle]')) return;
    ribbonError(target.closest('[data-c-ribbon]'), '');
  });

  // ブラウザの戻る（bfcache）やテーマエディタの再読込で、ラジオの状態と表示を合わせる
  function initAll(scope) {
    $$(scope || document, SEL.noshi).forEach(updateNoshi);
    $$(scope || document, SEL.carousel).forEach(updateCounter);
  }

  window.addEventListener('pageshow', function () { initAll(); });
  window.addEventListener('resize', function () { $$(document, SEL.carousel).forEach(updateCounter); });
  document.addEventListener('shopify:section:load', function (evt) { initAll(evt.target); });
  initAll();

  window.cGiftOptions = { refresh: initAll };
})();
